module.exports = __webpack_public_path__ + "static/media/career-seek-data-icon.07faa909.png";